import '../../node_modules/leaflet/dist/leaflet.css'
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import wms from 'leaflet.wms'

import 'leaflet-control-geocoder/dist/Control.Geocoder.css'
import 'leaflet-control-geocoder/dist/Control.Geocoder.min.js'

import 'leaflet.defaultextent/dist/leaflet.defaultextent.css'
import 'leaflet.defaultextent/dist/leaflet.defaultextent.js'

import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.min.js'

import 'leaflet-mouse-position/src/L.Control.MousePosition.css'
import 'leaflet-mouse-position/src/L.Control.MousePosition'

import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure.css'
import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure'
/*
import '@geoman-io/leaflet-geoman-free'
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css'
*/
import 'leaflet.browser.print/dist/leaflet.browser.print.min.js'

import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min.css'
import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min.js'

import { isArray, isEmpty } from 'lodash'

export function getFeatureInfoUrl (map, layer, latlng, params) {
  var point = map.latLngToContainerPoint(latlng, map.getZoom()),
    size = map.getSize(),
    bounds = map.getBounds(),
    sw = bounds.getSouthWest(),
    ne = bounds.getNorthEast()

  // sw = crs.projection._proj.forward([sw.lng, sw.lat])
  // ne = crs.projection._proj.forward([ne.lng, ne.lat])
  sw = [sw.lng, sw.lat]
  ne = [ne.lng, ne.lat]

  var defaultParams = {
    request: 'GetFeatureInfo',
    service: 'WMS',
    // srs: layer._crs.code,
    srs: 'EPSG:4674',
    styles: '',
    // version: layer._wmsVersion,
    version: '1.1.1',
    format: layer.options.format,
    bbox: [sw.join(','), ne.join(',')].join(','),
    height: size.y,
    width: size.x,
    layers: layer.options.layers,
    query_layers: layer.options.layers,
    info_format: 'application/json',
    exceptions: 'application/json',
    feature_count: 100 // FIXME
  }

  params = L.Util.extend(defaultParams, params || {})

  params[params.version === '1.3.0' ? 'i' : 'x'] = point.x
  params[params.version === '1.3.0' ? 'j' : 'y'] = point.y

  return layer._url + L.Util.getParamString(params, layer._url, true)
}

export function getLegendGraphicUrl (name) {
  var url = new URL(process.env.VUE_APP_GEOSERVER)

  url.searchParams.append('SERVICE', 'wms')
  url.searchParams.append('REQUEST', 'GetLegendGraphic')
  url.searchParams.append('VERSION', '1.0.0')
  url.searchParams.append('FORMAT', 'image/png')
  // url.searchParams.append('WIDTH', '20')
  // url.searchParams.append('HEIGHT', '20')
  url.searchParams.append('LAYER', name)
  url.searchParams.append('TRANSPARENT', true)
//  url.searchParams.append('LEGEND_OPTIONS', 'fontName:DejaVu Sans;fontSize:12;fontAntiAliasing:true')
  url.searchParams.append('LEGEND_OPTIONS', 'fontAntiAliasing:true')

  return url.toString()
}

export function createLegend (map) {
  var legend = L.control({
    position: 'bottomright'
  })

  var div = L.DomUtil.create('div', 'leaflet-info leaflet-legend')

  map.on('overlayadd', (e) => {
    if (e.layer.wmsParams) {
      var name = e.name
      var layers = e.layer.wmsParams.layers
      div.innerHTML = '<strong>' + name + '</strong><br />'
      div.innerHTML += '<img src="' + getLegendGraphicUrl(layers) + '">'
      div.innerHTML += '<br />'
    }
  })

  map.on('overlayremove', () => { /* (e) */
    div.innerHTML = ''
  })

  legend.onAdd = () => { /* map */

/*
    div.innerHTML += '<div>'
    div.innerHTML += '<img style="vertical-align:middle" src="' + this.getLegendGraphicUrl('itcg:municipios_pr_pol_p31982_e50_a2014') + '">'
    div.innerHTML += '<span style="margin-left: 8px; margin-right: 8px"><strong>Municípios do Paraná</strong></span>'
    div.innerHTML += '</div>'
*/

    map.eachLayer(layer => {
      if (layer.wmsParams) {
        var layers = layer.wmsParams.layers
        // div.innerHTML += '<strong>Municípios do Paraná</strong><br />'

        div.innerHTML += '<img src="' + getLegendGraphicUrl(layers) + '">'
        div.innerHTML += '<br />'
      }
    })

    /*
    div.innerHTML += '<strong>Municípios do Paraná</strong><br />'
    div.innerHTML += '<img src="' + getLegendGraphicUrl('itcg:municipios_pr_pol_p31982_e50_a2014') + '">'
    div.innerHTML += '<br />'

    div.innerHTML += '<strong>Contorno do Paraná</strong><br />'
    div.innerHTML += '<img src="' + getLegendGraphicUrl('itcg:contorno_pr_pol_p31982_e50_a2014') + '">'
    */

    return div
  }

  legend.addTo(map)

  return legend
}

export function createMeasure (map) {
  L.control.polylineMeasure({
    measureControlTitleOn: 'Medir Distância',
    measureControlTitleOff: 'Finalizar'
  }).addTo(map)
}

export function mousePosition (map) {
  L.control.mousePosition({
    position: 'bottomright'
  }).addTo(map)
}
/*
export function createEditor (map) {
  map.pm.addControls({
    position: 'topleft',
    drawCircleMarker: false
  })

  map.pm.setLang('pt-br', {
    'tooltips': {
      'placeMarker': 'Clique para posicionar o marcador',
      'firstVertex': 'Clique para posicionar o primeiro vértice',
      'continueLine': 'Clique para continuar desenhando',
      'finishLine': 'Clique em qualquer marcador existente para finalizar',
      'finishPoly': 'Clique no primeiro ponto para fechar o polígono',
      'finishRect': 'Clique para finalizar',
      'startCircle': 'Clique para posicionar o centro do círculo',
      'finishCircle': 'Clique para fechar o círculo'
    },
    'actions': {
      'finish': 'Finalizar',
      'cancel': 'Cancelar',
      'removeLastVertex': 'Remover último vértice'
    },
    'buttonTitles': {
      'drawMarkerButton': 'Desenhar um marcador',
      'drawPolyButton': 'Desenhar um polígono',
      'drawLineButton': 'Desenhar uma polilinha',
      'drawCircleButton': 'Desenhar um círculo',
      'drawRectButton': 'Desenhar um retângulo',
      'editButton': 'Editar camada(s)',
      'dragButton': 'Mover camada(s)',
      'cutButton': 'Recortar camada(s)',
      'deleteButton': 'Remover camada(s)'
    }
  }, 'en')
}
*/

export function createBaseLayers (map) {
  var baseLayers = {
    'ESRI Gray': esri.basemapLayer('Gray'),
    'ESRI Imagery': esri.basemapLayer('Imagery'),
    'ESRI Topographic': esri.basemapLayer('Topographic'),
    'OpenStreetMap': L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    })
  }

  var baseLayer = baseLayers['ESRI Topographic']
  baseLayer.addTo(map)

  return baseLayers
}

export function createGroupedOverlays () {
  var Source = wms.Source.extend({
    parseFeatureInfo: function (result) { // url
      var json = JSON.parse(result)
      if (json.features.length === 0) return 'Sem dados disponíveis'

      var properties = json.features[0].properties
      var html = '<table style="border: 2px">'
      for (var property in properties) {
        html += '<tr><td style="padding-top: 4px; padding-bottom: 4px; padding-right: 4px"><b>' + property + '</b></td>'
        html += '<td style="padding-top: 4px; padding-bottom: 4px">' + properties[property] + '</td></tr>'
      }
      html += '</table>'
      return html
    }
  })

  var source = new Source(process.env.VUE_APP_GEOSERVER, {
    format: 'image/png',
    info_format: 'application/json',
    transparent: true,
    tiled: true
  })

  /*
  var source = wms.source(process.env.VUE_APP_GEOSERVER, {
    format: 'image/png',
    info_format: 'text/html',
    transparent: true,
    tiled: true
  })
  */

  var groupedOverlays = {
    'Municípios': {
      'Municípios do Paraná': source.getLayer('seec:municipios_seec_pol_p29192_e3000_a2013'),
      'IDHM Municípios Paraná (2010)': source.getLayer('ipardes:idhm_municipio_pol_p4674_a2010')
    },
    'Regionais': {
      'Regionais de Curitiba': source.getLayer('seec:regionais_curitiba_fcc_pol_p29192'),
      'Regionais SEEC': source.getLayer('seec:regionais_seec_pol_p29192_e3000_preenchido'),
      'Regionais SEEC Contorno': source.getLayer('seec:regionais_seec_pol_p29192_e3000'),
      'Macrorregionais SEEC': source.getLayer('seec:macro_regionais_seec_pol_p29192_e3000_preenchido'),
      'Macrorregionais SEEC Contorno': source.getLayer('seec:macro_regionais_seec_pol_p29192_e3000'),
      'Tombamento da Serra do Mar': source.getLayer('seec:area_tombamento'),
      'Tombamento por Município': source.getLayer('seec:tombamento_por_municipio'),
      'Patrimônio Cultural': source.getLayer('seec:patrimonio')
    }
  }

  return groupedOverlays
}

// WFS Contorno do Paraná
/*
export function getExtent () {
  axios.get(process.env.VUE_APP_GEOSERVER, {
    params: {
      service: 'wfs',
      version: '2.0.0',
      outputFormat: 'application/json',
      exceptions: 'application/json',
      request: 'GetFeature',
      typeNames: 'itcg:contorno_pr_pol_p31982_e50_a2014',
      srsName: 'EPSG:4674'
    }
  })
    .then(response => {
      console.log('getExtent')
      console.log(L.geoJson(response.data).getBounds())
    })
}
*/

export function getBounds () {
  var ne = L.latLng(-22.51664754, -48.02383566),
    sw = L.latLng(-26.71623274, -54.61930655),
    bounds = L.latLngBounds(ne, sw)

  return bounds
}

/**
 * Converts an Object to ViewParams String.
 * @author Andre Huller <ahuller@celepar.pr.gov.br>
 * @param {Object} viewParams
 * @returns {string}
 */
export function toViewParams (viewParams) {
  //  FIXME: i --> name
  var params = []

  for (var i in viewParams) {
    var value = null

    if (isArray(viewParams[i])) {
      if (!isEmpty(viewParams[i])) {
        if (isNaN(viewParams[i][0])) {
          value = viewParams[i].map((param) => "'" + param + "'").join('\\,')
        } else {
          value = viewParams[i].join('\\,') // FIXME ??
        }
      }
    } else if (viewParams[i]) {
      value = viewParams[i]
    }

    if (value) {
      params.push([i, value].join(':'))
    }
  }

  return params.join(';')
}

/* Custom Controls */
/**
 * Creates the GetFeatureInfo Control
 * @author Andre Huller <ahuller@celepar.pr.gov.br>
 */
/*
export function getFeatureInfo (map, layer) {
  L.Control.GetFeatureInfo = L.Control.extend({
    options: {
      position: 'topleft',
      text: 'Informações',
      title: 'Informações',
      className: 'leaflet-control-getfeatureinfo',
      enabled: false
    },
    onAdd: function (map) {
      this._map = map
      var container = L.DomUtil.create('div', 'leaflet-bar '
        + this.options.className)

      var link = L.DomUtil.create('a', this.options.className + '-toggle', container)
      link.href = "#"
      link.title = this.options.title

      L.DomEvent
        .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
        .on(link, 'click', L.DomEvent.stop)
        .on(link, 'click', this._toggleGetFeatureInfo, this)

      this._anchor = link
      return container
    },
    onRemove: function () {
      // ..
    },
    _toggleGetFeatureInfo: function () {
      this.options.enabled = !this.options.enabled
      if (this.options.enabled) {
        this._map.on('click', this._getFeatureInfo, this)
        this._anchor.classList.add('leaflet-control-active')
      } else {
        this._map.off('click', this._getFeatureInfo, this)
        this._anchor.classList.remove('leaflet-control-active')
      }
    },
    _getFeatureInfo: function (e) {
      var url = getFeatureInfoUrl(this._map, layer, e.latlng)

      var template = `
        <h2>{nome}</h2>
        <p><strong>Código IBGE</strong>: {codibge}</p>
        <p><strong>Dirigente Municipal</strong>: {dirigentemunicipal}</p>
        <p><strong>E-mail Dirigente Municipal</strong>: {email}</p>
        <p><strong>População</strong>: {pop2010}</p>
        <p><strong>IDHM (2000)</strong>: {idhm_2000}</p>
      `

      axios.get(url)
        .then(response => {
          console.log(response.data)
          var feature = response.data.features[0]

          if (feature) {
            L.popup()
              .setLatLng(e.latlng)
              .setContent(L.Util.template(template, feature.properties))
              .openOn(this._map)
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  })

  return new L.Control.GetFeatureInfo(map)
}
*/

export function homeExtent (map) {
  L.Control.HomeExtent = L.Control.extend({
    options: {
      position: 'topleft',
      text: 'Visão Inicial',
      title: 'Visão Inicial',
      className: 'leaflet-control-homeextent'
    },
    onAdd: function (map) {
      this._map = map
      var container = L.DomUtil.create('div', 'leaflet-bar '
        + this.options.className)

      // this._container = container

      var link = L.DomUtil.create('a', this.options.className + '-toggle', container)
      link.href = "#"
      // link.innerHTML = this.options.text
      link.title = this.options.title

      L.DomEvent
        .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
        .on(link, 'click', L.DomEvent.stop)
        .on(link, 'click', this._fitBounds, this)

      return container
    },
    onRemove: function () {
      // ..
    },
    _fitBounds: function () {
      this._map.fitBounds(getBounds())
    }
  })

  return new L.Control.HomeExtent(map)
}

export function watermark () {
  L.Control.Watermark = L.Control.extend({
    onAdd: function () { /* map */
      var img = L.DomUtil.create('img')
      img.src = require('@/assets/logo.png')
      img.style.width = '200px'

      return img
    },
    onRemove: function () { /* map */
      // Nothing to do here
    }
  })

  L.control.watermark = function (opts) {
    return new L.Control.Watermark(opts)
  }

  return L.control.watermark({
    position: 'bottomleft'
  })
}
